import { GroopitFilterComponentDisplayDTO } from "groopit-js/client";
import {
  getComponentIcon,
  getComponentName,
} from "../../Assignments/ComponentTypes";
import React from "react";
import { useMemo } from "react";
import { createFilterRemoveComponentAction } from "../State/FilterActions";
import { IconButton } from "@material-ui/core";
import { DeleteOutlined } from "@material-ui/icons";
import { useFilterDispatchContext } from "../State/FilterDispatchContext";

interface StaleComponentFilterProps {
  assignmentId: string;
  filter: GroopitFilterComponentDisplayDTO;
}

export const StaleComponentFilter = (props: StaleComponentFilterProps) => {
  const { assignmentId, filter } = props;
  const { filterDispatcher } = useFilterDispatchContext();

  const componentIcon = useMemo(
    () => getComponentIcon(filter.componentModelType),
    [filter.componentModelType],
  );

  const componentName = useMemo(
    () => getComponentName(filter.componentModelType),
    [filter.componentModelType],
  );

  return (
    <div>
      <div className="flex gap-2 p-4">
        <div className="w-8 h-8 p-1 flex-shrink-0">
          {componentIcon && (
            <img
              src={componentIcon}
              alt={componentName}
              className="w-full h-full"
            />
          )}
        </div>
        <div className="flex-grow self-center text-app-gray-06 text-l">
          <span>{filter.componentModelDescription}</span> ({"\u26a0"} deleted)
        </div>
        <IconButton
          color="secondary"
          onClick={() => {
            filterDispatcher(
              createFilterRemoveComponentAction(
                filter.componentModelId,
                assignmentId,
              ),
            );
          }}
          size="small"
          title="Remove data collection field filter"
          aria-label="Remove data collection field filter"
        >
          <DeleteOutlined />
        </IconButton>
      </div>
    </div>
  );
};
